import { initContract } from '@ts-rest/core';
const c = initContract();
export const entityContract = c.router({
    getById: {
        method: 'GET',
        path: '/entities/:id',
        summary: 'Get an entity by id',
        responses: {
            200: c.type(),
            404: c.type(),
        },
    },
    getAll: {
        method: 'GET',
        path: '/entities',
        summary: 'Get all entities',
        responses: {
            200: c.type(),
        },
    },
    create: {
        method: 'POST',
        path: '/entities',
        summary: 'Create an entity',
        body: c.type(),
        responses: {
            200: c.type(),
            400: c.type(),
            401: c.type(),
        },
    },
    delete: {
        method: 'DELETE',
        path: '/entities/:id',
        summary: 'Delete an entity by id',
        responses: {
            200: c.type(),
            404: c.type(),
            401: c.type(),
            500: c.type(),
        },
    },
    update: {
        method: 'PUT',
        path: '/entities/:id',
        summary: 'Update an entity name',
        body: c.type(),
        responses: {
            200: c.type(),
            400: c.type(),
            404: c.type(),
            401: c.type(),
        },
    },
});
//# sourceMappingURL=entity.js.map